import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { WorkflowDetailPage } from '@/features/workflows/workflow-detail-page';
import { isWorkflowTab, type WorkflowTab } from '@/features/workflows/workflow-tabs';
import { EntityName } from '@/features/references/entity-ref';

/** L'onglet actif vit dans l'URL (`?tab=runs`) : une capture ou un lien pointe sur un onglet précis. */
export const Route = createFileRoute('/$tenant/projects/$projectId/workflows/$workflowId/')({
  validateSearch: (search: Record<string, unknown>): { tab: WorkflowTab } => ({
    tab: isWorkflowTab(search['tab']) ? search['tab'] : 'summary',
  }),
  component: WorkflowDetailRoute,
});

function WorkflowDetailRoute() {
  const { tenant, projectId, workflowId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();

  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="workflows"
      crumbs={[
        { label: t('nav.items.workflows') },
        { label: <EntityName tenantId={tenant} kind="workflow" id={workflowId} scope={{ projectId }} /> },
      ]}
    >
      <WorkflowDetailPage
        tenantId={tenant}
        projectId={projectId}
        workflowId={workflowId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
